import indexDBReplica from './iDBReplica';
import idb from './idb';

export const OFFER_STORE = 'offer';
export const ENROLMENT_STORE = 'enrolment';
export const STATE_STORE = 'state';
export const STATE_STORE_INDEX = 'stateOfferUserIndex';
export const DATA_SYNC_STORE = 'dataSync';
export const STATE_INTERACTION_STORE = 'stateInteraction';
export const CONTENT_SETTINGS_STORE = 'contentSettings';
export const CUSTOM_PROPERTIES_STORE = 'customProperties';
export const LIBRARY_CONTENT_PIDS = 'libraryContentPids';
export const USER_STORE = 'user';
export const COMPANY_STORE = 'company';
export const CONTENT_DETAILS_STORE = 'contentDetails';
export const ALL_STORES = [
  OFFER_STORE,
  ENROLMENT_STORE,
  STATE_STORE,
  DATA_SYNC_STORE,
  STATE_INTERACTION_STORE,
  CONTENT_SETTINGS_STORE,
  CUSTOM_PROPERTIES_STORE,
  LIBRARY_CONTENT_PIDS,
  USER_STORE,
  CONTENT_DETAILS_STORE,
  COMPANY_STORE
];

/* To add NEW STORE in DB, increase the version in second parameter and
add new case for adding the store */
async function initDB() {
  let availableStorageInMB = 0;
  if ('storage' in navigator && 'estimate' in navigator.storage) {
    try {
      const storage = await navigator.storage.estimate();
      const totalStorage = storage.quota;
      const usedStorage = storage.usage;
      console.log('totalStorage in mb', totalStorage / 1024 / 1024);
      console.log('usedStorage in mb', usedStorage / 1024 / 1024);
      availableStorageInMB = (totalStorage - usedStorage) / 1024 / 1024;
      console.log('availableStorage in mb', availableStorageInMB);
    } catch (e) {
      availableStorageInMB = 100;
    }
  } else {
    availableStorageInMB = 100;
  }

  let indexDb;
  if (availableStorageInMB >= 50) {
    indexDb = idb;
  } else {
    indexDb = indexDBReplica;
  }

  return indexDb.open('learningSpace', 5, db => {
    // debugger;
    if (!db.objectStoreNames.contains(OFFER_STORE)) {
      db.createObjectStore(OFFER_STORE, { keyPath: '_id' });
    }
    if (!db.objectStoreNames.contains(ENROLMENT_STORE)) {
      db.createObjectStore(ENROLMENT_STORE, { keyPath: 'userId_contentId' });
    }
    if (!db.objectStoreNames.contains(STATE_STORE)) {
      const stateObjectStore = db.createObjectStore(STATE_STORE, {
        keyPath: 'userId_contentId'
      });
      stateObjectStore.createIndex(STATE_STORE_INDEX, 'userId_offerId', { unique: false });
    }
    if (!db.objectStoreNames.contains(DATA_SYNC_STORE)) {
      db.createObjectStore(DATA_SYNC_STORE, { keyPath: 'id' });
    }
    if (!db.objectStoreNames.contains(STATE_INTERACTION_STORE)) {
      db.createObjectStore(STATE_INTERACTION_STORE, {
        keyPath: 'contentId_interactionType_interactingOnId_actorId'
      });
    }
    if (!db.objectStoreNames.contains(CONTENT_SETTINGS_STORE)) {
      db.createObjectStore(CONTENT_SETTINGS_STORE, { keyPath: 'contentId' });
    }
    if (!db.objectStoreNames.contains(CUSTOM_PROPERTIES_STORE)) {
      db.createObjectStore(CUSTOM_PROPERTIES_STORE, { keyPath: 'propertyId' });
    }
    if (!db.objectStoreNames.contains(LIBRARY_CONTENT_PIDS)) {
      db.createObjectStore(LIBRARY_CONTENT_PIDS, { keyPath: 'keyName' });
    }
    if (!db.objectStoreNames.contains(USER_STORE)) {
      db.createObjectStore(USER_STORE, { keyPath: 'pid' });
    }
    if (!db.objectStoreNames.contains(CONTENT_DETAILS_STORE)) {
      db.createObjectStore(CONTENT_DETAILS_STORE, { keyPath: 'contentId' });
    }
    if (!db.objectStoreNames.contains(COMPANY_STORE)) {
      db.createObjectStore(COMPANY_STORE, { keyPath: 'pid' });
    }
  });
}

const dbPromise = initDB();

// eslint-disable-next-line consistent-return
export function writeData(st, data) {
  try {
    return dbPromise.then(db => {
      const tx = db.transaction(st, 'readwrite');
      const store = tx.objectStore(st);
      store.put(data);
      return tx.complete;
    });
  } catch (error) {
    console.log('Error in writing in IDB:', error);
    window.bugsnagClient && window.bugsnagClient.notify(error);
  }
}

// eslint-disable-next-line consistent-return
export function writeBatchData(st, batchedData) {
  try {
    return dbPromise.then(db => {
      const tx = db.transaction(st, 'readwrite');
      const store = tx.objectStore(st);
      batchedData.forEach(data => {
        store.put(data);
      });
      return tx.complete;
    });
  } catch (error) {
    console.log('Error in writing in IDB:', error);
    window.bugsnagClient && window.bugsnagClient.notify(error);
  }
}

export function readAllData(st) {
  return dbPromise.then(db => {
    const tx = db.transaction(st, 'readonly');
    const store = tx.objectStore(st);
    return store.getAll();
  });
}

export function readDataFromIndex(st, indexName, id) {
  return dbPromise.then(db => {
    const tx = db.transaction(st, 'readonly');
    const store = tx.objectStore(st);
    const index = store.index(indexName);
    return index.getAll(id);
  });
}

export function readData(st, id) {
  return dbPromise.then(db => {
    const tx = db.transaction(st, 'readonly');
    const store = tx.objectStore(st);
    return store.get(id);
  });
}

export function clearAllData(st) {
  return dbPromise.then(db => {
    const tx = db.transaction(st, 'readwrite');
    const store = tx.objectStore(st);
    store.clear();
    return tx.complete;
  });
}

export function deleteItemFromData(st, id) {
  return dbPromise.then(db => {
    const tx = db.transaction(st, 'readwrite');
    const store = tx.objectStore(st);
    store.delete(id);
    return tx.complete;
  });
}

export function clearAllIDBStores() {
  window.analytics &&
    window.analytics.track('CLEAR_INDEXDB_CALLED', {
      url: window.location.href,
      cookie: document.cookie
    });
  return dbPromise.then(db => {
    Object.values(db.objectStoreNames).forEach(st => {
      clearAllData(st);
    });
  });
}
